import styled from "styled-components";

export const Styles = styled.div`
  margin: 40px auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;

  .btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 23px;
    gap: 8px;
    max-width: 343px;
    height: 85px;
    line-height: 85px;
    width: 100%;
    border-radius: 4px;
    margin-bottom: 25px;
    background-color: #3396a2;
    border: 2px solid #3396a2;

    &-start.not_compatible {
      background-color: transparent;
      p {
        color: #3396a2;
      }
    }

    &-start.resolved {
      background-color: #0a00ff;
      border-color: #0a00ff;
    }

    &.transparent {
      background-color: transparent;

      p {
        color: #3396a2;
        font-family: "Lato";
        font-weight: 400;
      }
    }

    &-end {
      background-color: #ff0000;
      border: 2px solid #ff0000;
    }

    &-date {
      background-color: #ffffff;
      border: 2px solid #ff0000;
      display: flex;
      flex-direction: column;
      justify-content: start;
      justify-content: center;
      height: 115px;
      line-height: unset;

      p {
        &:first-child {
          color: #ff0000;
        }

        &:last-child {
          font-weight: 500;
          font-size: 29px;
          color: #000000;
        }
      }
    }

    p {
      width: 100%;
      font-family: "Lato";
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
    }
  }

  h3 {
    margin-top: 50px;
    font-family: "Inter";
    font-weight: 400;
    font-size: 22px;
    color: #1f3f5d;
    margin-bottom: 8px;
  }

  .box {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    width: 100%;
    align-items: center;

    .btn-date {
      background-color: #2e8135;
      border: 2px solid #2e8135;

      p {
        font-family: "Lato";
        font-weight: 400;
        font-size: 43px;
        color: #ffffff;
      }
    }
  }
`;
